<a md-button class="impersonate-btn" (click)="impersonate()" [md-tooltip]="tooltip()">
	<md-icon icon="untitled-ui/users/users-02"></md-icon>
</a>
